import printStyles from 'css/components/lesson-builder/print-overlay.module.css'

/**
 * @module lesson-builder/components/delete-confirm-overlay
 * @description The "are you sure" modal shown before a teacher deletes a
 * question. See docs/BLUEPRINT-2026-10-01-question-slide-decomposition.md.
 */
export const DeleteConfirmOverlay = ({ onConfirm, onCancel }: { onConfirm: () => void, onCancel: () => void }) => {
	return (
		<div className="overlay">
			<div className="overlay-content-container delete-confirm-container">
				<div className="overlay-content-header">
					Delete Question
				</div>
				<div className="overlay-content-body">
					<p className="delete-confirm-text">
						Some of your students may be left without questions for this section if you delete this question. Please make sure this is what you want to do.
					</p>
					<p className="delete-confirm-warning">
						THIS IS PERMANENT AND CAN'T BE UNDONE. Are you sure?
					</p>
					<div className={printStyles.navRow}>
						<div />
						<div className="delete-confirm-actions">
							<button className={printStyles.secondaryBtn} onClick={onCancel}>Cancel</button>
							<button className={printStyles.destructiveBtn} onClick={onConfirm}>Delete Question</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default DeleteConfirmOverlay
